export const NO_ASSETS_TEXT = 'No Assets Provided!';
